'use client'

import { isNil } from 'lodash-es'
import { ComponentProps, useEffect } from 'react'

import { useDialog } from '@/shared/lib'
import { AlertDialog, Button } from '@/shared/ui'

const DIALOG = {
  CERTIFICATION_FAILED: 'CERTIFICATION_FAILED',
} as const

type CertificationDialog = keyof typeof DIALOG

export type Props = ComponentProps<typeof Button> & {
  onSuccess: (certNum: string) => void
}

export const CertificationButton = ({
  onSuccess,
  children,
  ...props
}: Props) => {
  const { isOpen, open, closeHandler } = useDialog<CertificationDialog>()

  const openCertPopup = () => {
    window.open(
      `${process.env.NEXT_PUBLIC_API_URL}/v1/cert/kmc`,
      'KMC 본인확인서비스',
      `width=640,height=640`,
    )
  }

  useEffect(() => {
    const handleMessage = ({ origin, data }: MessageEvent) => {
      const { result, certNum, type } = data

      const isSameOrigin = origin === process.env.NEXT_PUBLIC_URL
      const isCertCallback = type === 'cert'

      if (!isSameOrigin || !isCertCallback) {
        return
      }

      if (result === 'fail') {
        open(DIALOG.CERTIFICATION_FAILED)

        return
      }

      if (result === 'success' && !isNil(certNum)) {
        onSuccess(certNum)
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  return (
    <>
      <Button fullWidth size="large" onClick={openCertPopup} {...props}>
        {children}
      </Button>

      <AlertDialog
        isOpen={isOpen(DIALOG.CERTIFICATION_FAILED)}
        onOpenChange={closeHandler(DIALOG.CERTIFICATION_FAILED)}
        content="본인인증에 실패했습니다."
      />
    </>
  )
}
